import React from 'react';
import ClassNames from 'classnames';
import { node, oneOf, oneOfType, string } from 'prop-types';

import './ContentInfo.scss';

const ContentInfo = props => {
  const { icon, title, description, type, actions } = props;

  const iconClassNames = ClassNames(
    'content-info__icon',
    description || actions ? '--mb-xs' : '--mb-xl'
  );

  return (
    <div className={`content-info content-info_${type}`}>
      <div className={iconClassNames}>{icon}</div>
      {React.isValidElement(title) ? (
        <div className="content-info__title">{title}</div>
      ) : (
        <span className="content-info__title">{title}</span>
      )}
      {React.isValidElement(description) ? (
        <div className="content-info__description text --md --mt-xs">
          {description}
        </div>
      ) : (
        <span className="text --md --mt-xs">{description}</span>
      )}
      <div className="content-info__actions --mt-xl">{actions}</div>
    </div>
  );
};

ContentInfo.propTypes = {
  icon: node.isRequired,
  title: oneOfType([node, string]).isRequired,
  description: oneOfType([node, string]),
  type: oneOf(['archived', 'empty', 'error', 'success']).isRequired,
  actions: node
};

ContentInfo.defaultProps = {
  description: null,
  actions: null
};

export default ContentInfo;
